import React, { useState } from 'react';
import { DataTable } from 'react-native-paper';
import PropTypes from 'prop-types';

import WaterUseDataTableHeader from './WaterUseDataTableHeader';
import WaterUseDataTablePagination from './WaterUseDataTablePagination';
import WaterUseDataTableRow from './WaterUseDataTableRow';
import WaterUseDataTableRowIrrigation from './WaterUseDataTableRowIrrigation';

function WaterUseDataTable({
  crops,
  irrigation,
  itemsPerPage,
  language,
  pageContent,
  unit,
}) {
  const [page, setPage] = useState(0);

  const from = page * itemsPerPage;

  const pageCrops = crops.slice(
    page * itemsPerPage,
    page * itemsPerPage + itemsPerPage
  );

  function sortCrops(crops) {
    return crops.sort((a, b) =>
      a.name > b.name ? 1 : a.name === b.name ? (a.size > b.size ? 1 : -1) : -1
    );
  }

  return (
    <DataTable>
      <WaterUseDataTableHeader pageContent={pageContent} />
      {sortCrops(pageCrops).map((crop) =>
        irrigation ? (
          <WaterUseDataTableRowIrrigation
            key={`row-${crop.name}`}
            crop={crop}
            unit={unit}
          />
        ) : (
          <WaterUseDataTableRow
            key={`row-${crop.name}`}
            crop={crop}
            unit={unit}
          />
        )
      )}
      <WaterUseDataTablePagination
        crops={crops}
        from={from}
        itemsPerPage={itemsPerPage}
        language={language}
        page={page}
        pageCrops={pageCrops}
        setPage={setPage}
      />
    </DataTable>
  );
}

WaterUseDataTable.propTypes = {
  crops: PropTypes.arrayOf(PropTypes.object),
  irrigation: PropTypes.bool,
  itemsPerPage: PropTypes.number,
  language: PropTypes.string,
  pageContent: PropTypes.arrayOf(PropTypes.string),
  unit: PropTypes.string,
};

export default WaterUseDataTable;
